import CancelIcon from '@mui/icons-material/Cancel';
import {Chip, ChipProps, mergeSlotProps} from '@mui/material';
import {type FC, useState} from 'react';
import {SHOW_SUPER_RES_BADGE_LOCAL_STORAGE_KEY} from '@src/constants/analyze';
import {useSuperResLayer} from '@src/hooks/useSuperResLayer.tsx';
import {Layer} from '@src/types/configurations';

const MagicChip: FC<ChipProps> = ({label, ...props}) => {
  return (
    <Chip
      {...mergeSlotProps(
        {
          sx: {
            fontSize: 9,
            height: 20,
            fontWeight: 500,
            background: 'linear-gradient(to right, #A6FFB3, #33B1C1)',
            '*': {
              color: 'primary.contrastText',
            },
            '& .MuiChip-deleteIcon': {
              opacity: 0.26,
              '&:hover': {
                opacity: 1,
              },
            },
          },
        },
        props ?? {},
      )}
      deleteIcon={
        <CancelIcon sx={{blockSize: 18}} role="button" aria-label="Dismiss" />
      }
      label={label}
    />
  );
};

export const SuperResDismissibleChip: FC<{layer: Layer}> = ({layer}) => {
  const {layer: superResLayer} = useSuperResLayer();
  const showSuperResChip = superResLayer?.id === layer?.id;
  const [show, setShow] = useState(
    window.localStorage.getItem(SHOW_SUPER_RES_BADGE_LOCAL_STORAGE_KEY) !==
      'false',
  );

  if (!show || !showSuperResChip) {
    return null;
  }

  return (
    <MagicChip
      clickable={false}
      onDelete={() => {
        setShow(false);
        localStorage.setItem(SHOW_SUPER_RES_BADGE_LOCAL_STORAGE_KEY, 'false');
      }}
      sx={{
        height: 20,
        marginInlineStart: 'auto',
        cursor: 'default',
      }}
      label="SuperRes available"
    />
  );
};

export default SuperResDismissibleChip;
